import React, { Component } from "react";
import { MdEdit } from "react-icons/md";
import { RiMapPinRangeFill } from "react-icons/ri";
import NeshanMap from "react-neshan-map-leaflet";
import { Link } from "react-router-dom";
import { mapKey } from "../../../../settings/config";

class EditShopCoordinates extends Component {
  constructor(props) {
    super(props);
    this.state = {
      shopUid: window.location.pathname.split("/")[2],
    };
  }
  render() {
    return (
      <div className="px-0">
        <div className="col-12 px-0 position-relative" id="map">
          <Link to={`/dashboard/${this.state.shopUid}/edit/map`}>
            <div
              style={{
                zIndex: "999",
                bottom: "10px",
                right: "10px",
                width: "40px",
                height: "40px",
              }}
              onClick={() => this.props.showMap(true)}
              className="position-absolute bg-white rounded-circle p-2"
            >
              <MdEdit className="w-100 h-100" />
            </div>
          </Link>
          <RiMapPinRangeFill
            size={24}
            className="position-absolute m-auto color-second"
            style={{
              zIndex: "999",
              top: "0",
              left: "0",
              bottom: "0",
              right: "0",
            }}
          />
          <a
            rel="noreferrer"
            target="_blank"
            href={`https://maps.google.com/?q=${this.props.coordinates.latitude},${this.props.coordinates.longitude}`}
          >
            <NeshanMap
              style={{
                height: "170px",
                top: "0",
                left: "0",
                width: "100%",
                borderRadius: "14px",
              }}
              options={{
                key: mapKey,
                center: [
                  this.props.coordinates.latitude,
                  this.props.coordinates.longitude,
                ],
                zoom: 13,
                maptype: "dreamy-gold",
                poi: true,
              }}
              onInit={(L, myMap) => {
                myMap.touchZoom.disable();
                myMap.doubleClickZoom.disable();
                myMap.scrollWheelZoom.disable();
                myMap.boxZoom.disable();
                myMap.keyboard.disable();
                myMap.dragging.disable();
              }}
              zoomControl={false}
            />
          </a>
        </div>
      </div>
    );
  }
}

export default EditShopCoordinates;
